import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  TextField,
} from '@mui/material';
import {
  Edit,
} from '@mui/icons-material';
import {DangerHexagon,Tool,CheckCircle} from "@mynaui/icons-react";

const ServiceProgressModal = ({ open, onClose, onComplete, isComplete }) => {
  const [serviceNotes, setServiceNotes] = useState(
    `Replacing the spares
- Replaced Deep Grove Ball Bearing
- Adjust span rotation
- Lubrication & General Servicing`
  );

  const handleMarkComplete = () => {
    onComplete();
  };

  const handleRunHealthChecks = () => {
    onClose();
    // This will trigger the health check - you can pass this as a prop if needed
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '24px',
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
    

        <DialogContent sx={{ p: 0, textAlign: 'center' }}>
          {!isComplete ? (
            // Service In-Progress View
            <>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px',
                  backgroundColor: '#FFFFFF',
                }}
              >
                <DangerHexagon style={{ fontSize: 36, color: '#C62828' }} />
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  color: '#212121',
                  fontSize: '1.5rem',
                }}
              >
                Service In-Progress
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: '#757575',
                  mb: 3,
                  fontSize: '0.875rem',
                }}
              >
                The technician initiated
                <br />
                the Service work
              </Typography>

              <TextField
                multiline
                rows={7}
                value={serviceNotes}
                onChange={(e) => setServiceNotes(e.target.value)}
                fullWidth
                sx={{
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#FAFAFA',
                    '& fieldset': {
                      borderColor: '#E0E0E0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#BDBDBD',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1976D2',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    fontSize: '0.875rem',
                    color: '#212121',
                    lineHeight: 1.6,
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <Edit
                      sx={{
                        fontSize: 18,
                        color: '#9E9E9E',
                        position: 'absolute',
                        bottom: 8,
                        right: 8,
                      }}
                    />
                  ),
                }}
              />

              <Button
                variant="contained"
                fullWidth
                onClick={handleMarkComplete}
                sx={{
                  backgroundColor: '#22C55E',
                  color: '#FFFFFF',
                  textTransform: 'none',
                  fontWeight: 500,
                  padding: '12px',
                  borderRadius: '8px',
                  mb: 2,
                  fontSize: '0.9375rem',
                  '&:hover': {
                    backgroundColor: '#16A34A',
                  },
                }}
              >
                Mark as complete
              </Button>

              <Button
                variant="contained"
                fullWidth
                onClick={onClose}
                sx={{
                  backgroundColor: '#0F172A',
                  color: '#FFFFFF',
                  textTransform: 'none',
                  fontWeight: 500,
                  padding: '12px',
                  borderRadius: '8px',
                  fontSize: '0.9375rem',
                  '&:hover': {
                    backgroundColor: '#1E293B',
                  },
                }}
              >
                Escalate to Supervisor
              </Button>
            </>
          ) : (
            // Service Complete View
            <>
              <Box
                sx={{
                  border: '2px solid #00A63E',
                  borderRadius: '16px',
                  background: 'linear-gradient(to bottom right, #f0f5f2ff 0%, #a9ecc1ff 100%)',
                  padding: '48px 24px',
                  margin: '0 auto 24px',
                  position: 'relative',
                }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    backgroundColor: 'transparent',
                  }}
                >
                  <CheckCircle />
                </Box>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: '#212121',
                    fontSize: '1.5rem',
                  }}
                >
                  Service Complete
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: '#6B7280',
                    fontSize: '0.875rem',
                    lineHeight: 1.5,
                  }}
                >
                  Bearing replacement has
                  <br />
                  been completed successfully
                </Typography>
              </Box>

              <Button
                variant="contained"
                fullWidth
                startIcon={<Tool />}
                onClick={handleRunHealthChecks}
                sx={{
                  backgroundColor: '#00A63E',
                  color: '#FFFFFF',
                  textTransform: 'none',
                  fontWeight: 500,
                  padding: '12px',
                  borderRadius: '8px',
                  fontSize: '0.9375rem'
                }}
              >
                Done
              </Button>
            </>
          )}
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default ServiceProgressModal;